'use client';

import { Typography } from '@/components/atoms/Typography/Typography';
import { IconPlus } from '@/components/atoms/AnimatedIcons/IconPlus/IconPlus';
import { useRef, useState } from 'react';
import * as Styled from './ProjectTable.styled';
import { useTranslations } from 'next-intl';

export interface IProjectTable {
  collapsibleOnMobile?: boolean;
  rows: {
    key: string;
    value: string;
  }[];
}

export function ProjectTable({
  collapsibleOnMobile = true,
  rows,
}: IProjectTable) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState<string>('auto');
  const refCollapsibleContent = useRef<HTMLDivElement>(null);

  const translations = useTranslations('project');
  const t = translations.raw('hero') as {
    openTable: string;
    closeTable: string;
    year: string;
    location: string;
    developer: string;
    architect: string;
    interiorDesigner: string;
    agency: string;
    services: string;
    client: string;
    reAgent: string;
    typology: string;
  };

  const handleExpandClick = () => {
    if (!isExpanded) {
      const height = refCollapsibleContent.current?.scrollHeight;
      setContentHeight(`${height}px`);
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <Styled.ProjectTable
      style={{ '--content-height': contentHeight } as React.CSSProperties}
    >
      {collapsibleOnMobile && (
        <Styled.CollapsibleHeader onClick={handleExpandClick}>
          <Typography text={isExpanded ? t.closeTable : t.openTable} />
          <IconPlus isExpanded={isExpanded} />
        </Styled.CollapsibleHeader>
      )}

      <Styled.CollapsibleContent
        isCollapsible={collapsibleOnMobile}
        isExpanded={isExpanded}
        ref={refCollapsibleContent}
      >
        {rows.map(
          (row, i) =>
            row.value && (
              <Styled.Row key={`row-${i}`}>
                <Typography
                  text={t[row.key as keyof typeof t]}
                  fontFamily="gt-america-regular"
                  color="tertiary"
                  lineHeight='sm'
                  className='table-key'
                />
                <Typography 
                  text={row.value} 
                  color="primary"
                  lineHeight='sm'
                  sizeMobile='lg'
                  className='table-value'
                />
              </Styled.Row>
            )
        )}
      </Styled.CollapsibleContent>
    </Styled.ProjectTable>
  );
}
